import { z } from 'zod';

export const UserSchema = z
  .object({
    salutation: z.string(),
    title: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    email: z.string().email(),
    street: z.string(),
    zipcode: z.string(),
    city: z.string(),
    country: z.string(),
    phone: z.string(),
  })
  .partial();

export const UpdateUserSchema = z.object({
  salutation: z.string().min(1, 'fields.salutation.errors.required'),
  title: z.string(),
  firstname: z.string().min(1, 'fields.firstname.errors.required'),
  lastname: z.string().min(1, 'fields.lastname.errors.required'),
  email: z
    .string()
    .min(1, 'fields.email.errors.required')
    .email('fields.email.errors.invalid'),
  street: z.string().min(1, 'fields.street.errors.required'),
  zipcode: z.string().min(1, 'fields.zipcode.errors.required'),
  city: z.string().min(1, 'fields.city.errors.required'),
  country: z.string().min(1, 'fields.country.errors.required'),
  // Shape only. The phone rules (required / plausibility) live in the checkout feature's
  // createUpdateUserSchema, because they depend on the hotel's phoneRequired flag and on
  // libphonenumber — neither of which belongs in the entity layer (samera/samera#3323).
  phone: z.string().optional(),
  comment: z.string().optional(),
});
